import { IStyle } from '~/assets/interfaces/classes'
import { Device } from '~/node_modules/@nuxtjs/device'

export const classDevice = (device: Device) => {
  return (module: IStyle) => {
    return {
      [module.mobile]: device.isMobileOrTablet,
      [module.desktop]: !device.isMobileOrTablet,
    }
  }
}
